// extracted by mini-css-extract-plugin
export default {"overlay":"BrandingOverlay_overlay__+4Ghp","fadeIn":"BrandingOverlay_fadeIn__UXZJE","logo":"BrandingOverlay_logo__I+DIi","pulse":"BrandingOverlay_pulse__8s1de"};